<template>
  <div class="manual-container">
    <p class="component-title">{{ $t('TheNavbar.createImprovedFeedback') }}</p>
    <div>
      <FileUploader
        :isUploaded="isUploaded"
        @toggleUpload="toggleUpload"
      />
      <p v-if="!isUploaded" class="text-danger">
        {{ $t('SAAI.CreateGradingPaper.UploadingGradingPaper.uploadMessage') }}
      </p>
    </div>
    <div v-if="isUploaded">
      <FileSetting />
      <div class="button-wrapper flex-even">
        <button @click="() => movePage()">
          {{ $t('SAAI.CreateImprovedFeedback.UploadingAnalysisResults.nextButton') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploader from './FileUploader.vue';
import FileSetting from './FileSetting.vue';
import { mapActions } from 'vuex';

export default {
  name: 'UploadAnalysisResults',
  components: {
    FileUploader,
    FileSetting,
  },
  data() {
    return {
      timer: null,
      isUploaded: false,
    };
  },
  methods: {
    ...mapActions('modal', ['AC_MODAL_OPEN']),
    ...mapActions('saaiImprovedFeedback', ['AC_SET_EMAIL']),
    toggleUpload(type) {
      this.isUploaded = type;
    },
    setEmail(value) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.AC_SET_EMAIL(value);
      }, 200);
    },
    movePage() {
      this.$router.push('setComment');
    },
  },
};
</script>

<style lang="scss" scoped>
.extracting-message {
  color: $MAIN_COLOR !important;
  font-weight: bold;
}
.part-name {
  margin-right: 10px;
  color: $MAIN_COLOR;
  span {
    font-weight: bold;
  }
}
.email-input {
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 1rem;
}
</style>
